import React, { useEffect } from "react";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { useActionHook } from "hooks";
import { pickBy } from "lodash";
import { useDealQueriesSelect, useReportsActions, useReportsQueriesSelector } from "store";
import { DateRangeValue } from "store/types";
import { formatNumberWithoutRounding } from "utils";

import { StyledStack } from "./StyledStack";

const firstKey = "deal";
const secondKey = "Open rounds";

const clientHardcodedColumns = ["Deal Name", "Round Size"];
interface Props {
  internalDateRange: DateRangeValue<string>;
}

export const Rounds: React.FC<Props> = ({ internalDateRange }) => {
  const { getFlatDataAction } = useReportsActions();
  const { filters } = useDealQueriesSelect();

  const { currency, exchangeMethod } = useReportsQueriesSelector();

  const { action, data: tableData, loading } = useActionHook(getFlatDataAction);

  useEffect(() => {
    action({
      dateRange: internalDateRange,
      currency,
      columns: [secondKey],
      exchangeMethod,

      groupBy: [[firstKey]],
      filters: pickBy(filters, (value) => value.length > 0)
    });
  }, [filters, internalDateRange]);

  return (
    <StyledStack
      sx={{
        maxWidth: 400,
        minWidth: 400,
        overflow: "hidden",
        flexShrink: 0,
        p: "16px 0"
      }}
    >
      <Typography sx={{ fontSize: "18px", fontWeight: 500, lineHeight: "24px", color: "#071F35", p: "0 16px" }}>
        Open Rounds
      </Typography>
      <AsyncContentMui isLoading={loading} boxProps={{ sx: { flexGrow: 1 } }} spinnerProps={{ size: 80 }}>
        <TableContainer sx={{ p: "0 16px" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {clientHardcodedColumns.map((column) => (
                  <TableCell
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "24px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}
                    key={column}
                  >
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData &&
                tableData.rows.map(({ deal_id, valueData }, index) => {
                  return (
                    <TableRow
                      onClick={() => {
                        deal_id && window.open(`/main/deal/${deal_id}/workspace`, "_blank", "noopener,noreferrer");
                      }}
                      key={index}
                      sx={{ cursor: "pointer" }}
                    >
                      {tableData.columns.map((column, index) => {
                        return (
                          <TableCell
                            sx={{
                              width: !index ? "70%" : "30%",
                              fontSize: "16px",
                              fontWeight: 400,
                              lineHeight: "24px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                            {...(index && { align: "center" })}
                            key={column.key}
                          >
                            {index
                              ? `${column.postfix || ""}${formatNumberWithoutRounding(Number(valueData[column.key]), 1)}`
                              : valueData[column.key]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </AsyncContentMui>
    </StyledStack>
  );
};
